import { useState, useEffect, useRef } from "react";
import { useUser } from "../../context/UserContext";

export const Comments = ({ loaId, org, authToken }) => {
  const [comment, setComment] = useState("");
  const [comments, setComments] = useState([]);
  const commentsContainerRef = useRef(null);
  const { user } = useUser();

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_BACKEND_URL}/API/V2/LOA/${loaId}/comments`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      },
    )
      .then((response) => response.json())
      .then((responseData) => {
        if (Array.isArray(responseData)) setComments(responseData);
      });
  }, [loaId, authToken]);

  useEffect(() => {
    if (commentsContainerRef.current) {
      commentsContainerRef.current.scrollTop = commentsContainerRef.current.scrollHeight;
    }
  }, [comments]);

  const handleAddComment = () => {
    if (!comment.trim()) {
      alert("Comment cannot be empty");
      return;
    }

    fetch(
      `${process.env.REACT_APP_BACKEND_URL}/API/V2/LOA/${loaId}/comments`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ commentText: comment, org }),
      },
    )
      .then((response) => response.json())
      .then((responseData) => {
        if (!responseData.error) {
          setComments((prev) => [...prev, responseData.comment]);
          setComment("");
        } else {
          alert(responseData.error);
        }
      })
      .catch((error) => console.error("Fetch error:", error));
  };

  return (
    <div className="bg-white rounded-xl p-6 shadow-[0_2px_8px_rgba(0,0,0,0.05)]">
      <p className="text-xs font-semibold text-gray-800 mb-3">Discussion Thread</p>

      <div
        ref={commentsContainerRef}
        className="max-h-[200px] overflow-y-auto mb-4 flex flex-col"
      >
        {comments.length === 0 && (
          <p className="text-xs text-gray-500">No comments yet.</p>
        )}
        {comments.map((c, index) => {
          const isOwn = c.commentedBy === user.username;
          return (
            <div
              key={index}
              className={`p-3 rounded-lg text-xs text-gray-800 mb-2.5 border-l-[3px] ${
                isOwn ? "border-jiojbm50 bg-jiojbm20" : "border-gray-200 bg-gray-100"
              }`}
            >
              <p>
                <strong>{isOwn ? `${c.commentedBy} (You)` : c.commentedBy}:</strong>{" "}
                {/* Rendered via JSX text interpolation (never innerHTML) so user input can't execute as markup */}
                <span className="whitespace-pre-line break-words">{c.commentText}</span>
              </p>
              <p className="text-gray-500 mt-1">
                {c.createdAt && new Date(c.createdAt).toLocaleString()}
              </p>
            </div>
          );
        })}
      </div>

      <div className="flex flex-col gap-2.5 pt-4 border-t border-gray-200">
        <textarea
          className="w-full h-20 border border-gray-200 rounded-lg p-3 text-xs resize-y outline-none focus:border-jiojbm50"
          placeholder="Type your comment or internal note here..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
        <div className="flex justify-end">
          <button
            onClick={handleAddComment}
            disabled={!comment.trim()}
            type="button"
            className={`px-6 py-2 rounded-full text-xs font-bold text-white ${
              comment.trim() ? "bg-jiojbm50 hover:bg-jiojbm60" : "bg-jiojbm60 opacity-40 cursor-not-allowed"
            }`}
          >
            Post Comment
          </button>
        </div>
      </div>
    </div>
  );
};
